import { NgModule }             from '@angular/core';
import { ScoreMappingsService } from './score-mappings.service';

@NgModule({
  providers: [ScoreMappingsService]
})
export class ScoreMappingModule { }
